export const EQUIPAMIENTO_COLUMNAS_STORAGE_KEY = 'EquipamientoGrid_columnas';

/** El orden es el del `thead`: es el orden en que el usuario ve las opciones en el selector. */
export const buildEquipamientoColumns = (intl) => [
	{ name: 'identificador', label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.identificador', defaultMessage: 'Identificador' }) },
	{ name: 'tipo', label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.tipo', defaultMessage: 'Tipo' }) },
	{ name: 'marca', label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.marca', defaultMessage: 'Marca' }) },
	{ name: 'modelo', label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.modelo', defaultMessage: 'Modelo' }) },
	{ name: 'vehiculo', label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.movil', defaultMessage: 'Móvil' }) },
];
